import React from 'react';
import styled from 'styled-components';

import Text from './Text';
import Link from '../util/link';
import BlueQuote from '../../images/icons/quotemarks/quote_blue.svg';
import GreenQuote from '../../images/icons/quotemarks/quote_green.svg';
import OrangeQuote from '../../images/icons/quotemarks/quote_orange.svg';
import YellowQuote from '../../images/icons/quotemarks/quote_yellow.svg';
import theme from '../../styles/theme';

const {
	breakPoints: { screenQuery },
	colors,
} = theme;

const quoteImages = {
	blue: BlueQuote,
	green: GreenQuote,
	orange: OrangeQuote,
	yellow: YellowQuote,
};

const RelatedLink = styled(Link)`
	display: block;
	text-align: center;
	margin-top: 30px;
`;

const QuoteAttribution = styled.div`
	display: flex;
	justify-content: ${props => (props.inSlider ? `center` : `start`)};
	align-items: center;
	* {
		text-align: left;
	}

	.attr-callout {
		max-width: ${props => (props.bioImage ? `275px` : `100%`)};
	}

	img {
		max-height: 100px;
		width: 100px;
		border-radius: 100%;
		margin-right: 30px;
	}
	&.quote-attr-wrapper {
		margin-left: 9%;
	}

	${screenQuery.small} {
		flex-wrap: wrap;
		.attr-callout {
			width: 100%;
			max-width: 100%;
		}
		* {
			text-align: center;
		}
		img {
			margin: 0 auto;
			margin-bottom: 8px;
		}
		&.quote-attr-wrapper {
			margin-left: 0;
		}
	}
`;

const Quote = styled.img`
	position: absolute;
	width: 7%;
	left: -9%;
`;
const Image = styled.img`
	width: 195px;
	height: 130px;
	margin-bottom: 30px;
	${screenQuery.small} {
		margin-bottom: 35px;
	}
`;

const SingleQuote = ({
	inSlider,
	source,
	title,
	quote,
	textAlign,
	logo,
	bioImage,
	bioLogo,
	relatedCustomerStory,
	...props
}) => {
	console.log('BIOLOGO!', bioLogo);
	const storyLink = relatedCustomerStory
		? `/customer-stories/${relatedCustomerStory}/`
		: null;

	return (
		<div {...props}>
			{logo && !inSlider && <Image css={{ margin: '0 auto' }} src={logo} />}
			<div css={{ position: 'relative', marginLeft: '9%' }}>
				<Quote src={quoteImages[props.quoteImageColor] || quoteImages.orange} />
				<Text
					textAlign={textAlign || 'center'}
					className="quote-content"
					component="quoteBody"
					css={{ marginBottom: bioImage ? 60 : 20 }}
				>
					{quote}
				</Text>
			</div>
			<QuoteAttribution
				className="quote-attr-wrapper"
				bioImage={bioImage}
				inSlider={inSlider}
			>
				{bioImage && <img src={bioImage} />}
				<div className="attr-callout">
					{source && (
						<Text component="quoteName" css={{ marginTop: 7 }}>
							{source}
						</Text>
					)}
					{title && (
						<Text css={source && { marginTop: 7 }} component="quoteTitle">
							{title}
						</Text>
					)}
					{bioLogo && <img src={bioLogo} alt="" />}
					{storyLink && !inSlider && (
						<Link to={storyLink} css={{ display: 'block', paddingTop: 7 }} caps>
							Read the case study
						</Link>
					)}
				</div>
			</QuoteAttribution>
			{storyLink && inSlider && (
				<RelatedLink to={storyLink} caps>
					Read the case study
				</RelatedLink>
			)}
		</div>
	);
};

export default SingleQuote;
